import { useEffect, useState } from "react"

import { Progress } from "@/components/ui/progress"

// Words written against the order's target (the legacy page's Content
// Progress). The count is a live document read, so it loads after the page;
// until it arrives, or if it cannot be read, the target still shows.
export default function WordProgress({ progress }) {
  const [written, setWritten] = useState(null)
  const url = progress?.url

  useEffect(() => {
    if (!url) return undefined
    let live = true
    fetch(url, { headers: { Accept: "application/json" }, credentials: "same-origin" })
      .then((response) => (response.ok ? response.json() : null))
      .then((data) => {
        if (live && data) setWritten(Number(data.doc_word_count) || 0)
      })
      .catch(() => {})
    return () => {
      live = false
    }
  }, [url])

  if (!progress?.target) return null

  const target = progress.target
  const percent = written == null ? 0 : Math.min(100, Math.round((written / target) * 100))
  const count = written == null ? `Target ${target.toLocaleString()}` : `${written.toLocaleString()} of ${target.toLocaleString()}`

  return (
    <div className="mt-4 rounded-xl border border-border bg-card px-5 py-4 max-[560px]:px-4">
      <div className="mb-2 flex items-center justify-between gap-3 text-[12.5px] font-semibold">
        <span>Words written</span>
        <span className="tabular-nums text-muted-foreground">{count}</span>
      </div>
      <Progress value={percent} aria-label="Words written" />
    </div>
  )
}
